export const LOGIN_REQUEST = 'cap/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'cap/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'cap/LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'cap/LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'cap/LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'cap/LOGOUT_FAILURE';

export const SIDEBAR_MENU_ITEM_POSITION = 'left';
export const ORG_SETTINGS_URL = '/org/index';
export const HELP_URL = 'https://docs.capillarytech.com/';

export const CLEAR_TOPBAR_MENU_DATA = 'cap/CLEAR_TOPBAR_MENU_DATA';

export const GET_USER_DATA_REQUEST = 'cap/GET_USER_DATA_REQUEST';
export const GET_USER_DATA_SUCCESS = 'cap/GET_USER_DATA_SUCCESS';
export const GET_USER_DATA_FAILURE = 'cap/GET_USER_DATA_FAILURE';

export const SWITCH_ORG_REQUEST = 'cap/SWITCH_ORG_REQUEST';
export const SWITCH_ORG_SUCCESS = 'cap/SWITCH_ORG_SUCCESS';
export const SWITCH_ORG_FAILURE = 'cap/SWITCH_ORG_FAILURE';

export const PRODUCTION = 'production';

export const EXTENSIONS_MODULE = '/home/ui/extension';

export const LAST_SYNC_TIME_REQUEST = 'cap/LAST_SYNC_TIME_REQUEST';
export const LAST_SYNC_TIME_SUCCESS = 'cap/LAST_SYNC_TIME_SUCCESS';
export const LAST_SYNC_TIME_FAILURE = 'cap/LAST_SYNC_TIME_FAILURE';

export const GA_TRACKING_ID = 'UA-219853765-1';

export const GET_BEAMER_POSTS_EXPLORE_REQUEST =
  'Cap/GET_BEAMER_POSTS_EXPLORE_REQUEST';
export const GET_BEAMER_POSTS_EXPLORE_SUCCESS =
  'Cap/GET_BEAMER_POSTS_EXPLORE_SUCCESS';
export const GET_BEAMER_POSTS_EXPLORE_FAILURE =
  'Cap/GET_BEAMER_POSTS_EXPLORE_FAILURE';

export const GET_BEAMER_POSTS_NOTIFICATION_REQUEST =
  'Cap/GET_BEAMER_POSTS_NOTIFICATION_REQUEST';
export const GET_BEAMER_POSTS_NOTIFICATION_SUCCESS =
  'Cap/GET_BEAMER_POSTS_NOTIFICATION_SUCCESS';
export const GET_BEAMER_POSTS_NOTIFICATION_FAILURE =
  'Cap/GET_BEAMER_POSTS_NOTIFICATION_FAILURE';

export const EMPTY_STATE_TYPES = {
  EMPTY_EXTENSION_LIST: 'EMPTY_EXTENSION_LIST',
  EMPTY_EXTENSION_DATA: 'EMPTY_EXTENSION_DATA',
  EMPTY_EXTENSION_CONFIGURATION_IN_OVERVIEW:
    'EMPTY_EXTENSION_CONFIGURATION_IN_OVERVIEW',
  DISABLED_EXTENSION_CONFIGURATION_IN_OVERVIEW:
    'DISABLED_EXTENSION_CONFIGURATION_IN_OVERVIEW',
};

export const GET_SUPPORTED_LOCALES_REQUEST =
  'cap/GET_SUPPORTED_LOCALES_REQUEST';
export const GET_SUPPORTED_LOCALES_SUCCESS =
  'cap/GET_SUPPORTED_LOCALES_SUCCESS';
export const GET_SUPPORTED_LOCALES_FAILURE =
  'cap/GET_SUPPORTED_LOCALES_FAILURE';

export const capillaryString = 'capillary';
export const capillaryAboutUsPageLink = 'https://www.capillarytech.com/about-us/';
export const capillaryContactDetail = '+91 806-840-4468';

